// Supabase admin client - service role key guarded at runtime
import { envConfigs } from '@/constants/constants';
import { createClient } from '@supabase/supabase-js';
import { Database } from '../../../database.types';

// Validate required credentials
const supabaseUrl = envConfigs.supabase.url;
const serviceRoleKey = process.env.SUPABASE_SERVICE_ROLE_KEY;

if (!supabaseUrl || !serviceRoleKey) {
  console.warn(
    'Supabase admin client WARNING: NEXT_PUBLIC_SUPABASE_URL or SUPABASE_SERVICE_ROLE_KEY environment variables are missing.'
  );
}


// Server-side Supabase client with service role key for admin operations
export const supabaseAdmin = (supabaseUrl && serviceRoleKey)
  ? createClient<Database>(
    supabaseUrl as string,
    serviceRoleKey as string,
    {
      auth: {
        autoRefreshToken: false,
        persistSession: false
      },
      db: {
        schema: 'public',
      },
      global: {
        headers: {
          'X-Client-Info': 'supabase-admin-client',
        },
      },
      // Add connection pool configuration to prevent memory leaks
      realtime: {
        params: {
          eventsPerSecond: 10,
        },
      },
    }
  )
  : null as unknown as ReturnType<typeof createClient<Database>>;

// Check if service role key is available
export const hasServiceRoleKey = !!process.env.SUPABASE_SERVICE_ROLE_KEY;
